var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M38.182 12c1.004 0 1.818.814 1.818 1.818v20.364A1.818 1.818 0 0138.182 36H9.818A1.818 1.818 0 018 34.182V13.818C8 12.814 8.814 12 9.818 12h28.364zM38 14H10v20h28V14zm-10 1c4.843 0 8.75 4.039 8.75 9s-3.907 9-8.75 9a8.518 8.518 0 01-4-.993A8.516 8.516 0 0120 33c-4.843 0-8.75-4.039-8.75-9s3.907-9 8.75-9c1.443 0 2.803.359 4.001.993A8.504 8.504 0 0128 15zm-8 2a7 7 0 102.126 13.67A9.097 9.097 0 0119.25 24a9.097 9.097 0 012.875-6.67A6.954 6.954 0 0020 17zm8 0c-.74 0-1.455.115-2.126.33A9.097 9.097 0 0128.75 24a9.097 9.097 0 01-2.875 6.67A7 7 0 1028 17zm-4 1.256l-.093.066A6.988 6.988 0 0021 24a6.989 6.989 0 003 5.744A6.985 6.985 0 0027 24a6.989 6.989 0 00-3-5.744z", fill: "currentColor", stroke: "none", strokeWidth: 1, fillRule: "evenodd" })));
});
